import React, { useEffect, useState, useContext } from 'react';
import { Avatar, Typography, Box } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { AppContext } from './AppProvider';
import { AuthContext } from "./Auth";

// Simple cache to avoid repeated lookups
const userCache = {};

export default function ChatUserHeader({ senderId }) {
  const { authUser, authInstance, firestoreInstance, functionsInstance, storageInstance } = useContext(AuthContext);
  const [user, setUser] = useState({ displayName: 'User', photoURL: '' });

  useEffect(() => {
    let mounted = true;
    async function fetchUser() {
      if (userCache[senderId]) {
        setUser(userCache[senderId]);
        return;
      }
      try {
        // Use full path string for doc()
        const userDoc = await getDoc(doc(firestoreInstance, `users/${senderId}`));
        if (userDoc.exists()) {
          const data = userDoc.data();
          const displayName = data.displayName || 'User';
          const photoURL = data.photoURL || '';
          const userObj = { displayName, photoURL };
          userCache[senderId] = userObj;
          if (mounted) setUser(userObj);
        }
      } catch (err) {
        console.error('Error fetching user:', senderId, err);
        if (mounted) setUser({ displayName: 'User', photoURL: '' });
      }
    }
    if (senderId) fetchUser();
    return () => { mounted = false; };
  }, [senderId, firestoreInstance]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
      <Avatar src={user.photoURL} sx={{ width: 24, height: 24, mr: 1 }} />
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
        {user.displayName}
      </Typography>
    </Box>
  );
}
